import React from 'react';
import { t } from '@sm/intl';
import { DetailsFeatureRowPackages } from '~app/pages/Pricing/transformers/details/types';
import PackageDefs from '~app/pages/Pricing/lib/packages/packageDefs';

import useCategoryStyles from './useStyles';
import COPY from './copy';

export default function FeatureCell(pkg: DetailsFeatureRowPackages): JSX.Element {
  const { Cell, Bullet, BulletInverse, Highlighted } = useCategoryStyles({ packageName: pkg.packageName });
  let a11yValue = t(COPY.UNAVAILABLE);

  if (typeof pkg.value === 'string') {
    a11yValue = pkg.value;
  } else if (pkg.value) {
    a11yValue = t(COPY.AVAILABLE);
  }

  return (
    <div
      role="cell"
      aria-label={`${pkg.packageName} ${a11yValue}`}
      className={`${Cell} ${PackageDefs[pkg.packageName]?.highlighted ? Highlighted : ''}`}
      tabIndex={-1}
      data-testid="FeatureCell"
    >
      {typeof pkg.value === 'boolean'
        ? pkg.value && <span className={PackageDefs[pkg.packageName].highlighted ? BulletInverse : Bullet} />
        : pkg.value}
    </div>
  );
}
